/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { Config, SessionController } from '@increff/commons';

@Injectable()
export class Rest {
    constructor(private sessionController: SessionController, private config: Config) { }

    get jumpUrl() { return this.sessionController?.sessionUrl + 'jump'; }

    get authUrl() { return this.sessionController?.apiBaseUrl + 'auth/'; }

    get loginUrl() { return this.config?.startupData?.loginUrl; }

    get logoutUrl() { return this.config?.startupData?.logoutUrl; }

    get constantsBaseUrl() { return this.sessionController?.apiBaseUrl + 'constants/api/'; }

    get registerBaseUrl() { return this.sessionController?.apiBaseUrl + 'register/api/'; }

    get domainBaseUrl() { return this.sessionController?.apiBaseUrl + 'domain/api/'; }

    get domainAdminBaseUrl() { return this.sessionController?.apiBaseUrl + 'domain-admin/api/';}

    get domainUserBaseUrl() { return this.sessionController?.apiBaseUrl + 'domain-user/api/'; }

    get adminBaseUrl() { return this.sessionController?.apiBaseUrl + 'admin/api/'; }

    get adminBaseIpUrl() { return this.sessionController?.apiBaseUrl + 'admin/api/domain/ip'; }

    get adminAuditBaseUrl() { return this.adminBaseUrl + 'audit'; }

    get domainAuditBaseUrl() { return this.domainBaseUrl + 'audit'; }

    // Constants API controller

    get auditActionsUrl() { return `${this.constantsBaseUrl}audit-actions`; }
    get loginModesUrl() { return `${this.constantsBaseUrl}auth-modes`; }
    get defaultRolesUrl() { return `${this.constantsBaseUrl}default-roles`; }
    get bulkAddUsersTemplateGuideDataUrl() { return `${this.constantsBaseUrl}user-add-template`; }
    get userMigrationTemplateGuideDataUrl() { return `${this.constantsBaseUrl}user-migration-template`; }
    get bulkUpdateUsersTemplateGuideDataUrl() { return `${this.constantsBaseUrl}user-role-template`; }

    // Domain Admin api controller

    get domainApplicationResourcesUrl() { return this.domainBaseUrl + 'app-resource'; }
    get domainAuditLogUrl() { return this.domainAuditBaseUrl; }
    get domainAuditReportUrl() { return this.domainAuditBaseUrl; }
    get domainAdminAuthenticationUrl() { return this.domainBaseUrl + 'authentication'; }
    get domainDetailsUrl() {return this.domainBaseUrl + 'domain-details'; }
    get allDomainResourcesUrl() { return this.domainBaseUrl + 'domain-resource'; }
    get createDomainResourceUrl() { return this.domainBaseUrl + 'domain-resource'; }
    get allDomainRolesUrl() { return this.domainBaseUrl + 'role'; }
    get allDomainUserRolesUrl() { return this.domainBaseUrl + 'app-role'; }
    getAllDomainUserForResourceTypeUrl(roleId: number) { return `${this.domainBaseUrl}roles/${roleId}/users`; }
    get allDomainUsersUrl() { return this.domainBaseUrl + 'user'; }
    get addDomainUserUrl() {return this.domainBaseUrl + 'user'; }
    getToggleDomainUserStateUrl(userId: number) { return `${this.domainBaseUrl}user-enable/${userId}`; }
    getDomainUserChangePasswordUrl(userId: number) { return `${this.domainBaseUrl}user-password/${userId}`; }
    getResetDomainUserUrl(userId: number) { return `${this.domainBaseUrl}user-reset/${userId}`; }
    get domainBulkUploadUserRolesUrl() { return `${this.domainBaseUrl}/user-role`;}
    getDomainUserRolesUrl(userId: number) { return `${this.domainBaseUrl}user-role/${userId}`; }
    getUpdateDomainUserRolesUrl(userId: number) { return `${this.domainBaseUrl}user-role/${userId}`; }
    getDomainUserChangeLoginModeUrl(userId: number) { return `${this.domainBaseUrl}user-security/${userId}`; }
    get domainBulkAddUsersUrl() { return `${this.domainBaseUrl}user/bulk`; }
    get domainUserDetailsReportUrl() { return `${this.domainBaseUrl}user/report`; }
    getUpdateDomainUserDetailsUrl(userId: number) { return `${this.domainBaseUrl}user/${userId}`; }
    getDomainUserDetailsByIdUrl(userId: number) { return `${this.domainBaseUrl}user/${userId}`; }

    // Domain Superadmin Controller
    get updateDomainSettingsUrl() { return this.domainAdminBaseUrl + 'configurations'; }
    getToggleDomainUserVerificationStatusUrl(userId: number) { return `${this.domainAdminBaseUrl}email-verification/${userId}`; }
    getToggleDomainUserMFAStatusUrl(userId: number) { return `${this.domainAdminBaseUrl}mfa-verification/${userId}`; }
    get domainUserVerificationReport() { return `${this.domainAdminBaseUrl}user-report`; }
    get domainUserVerificationFileUploadUrl() { return `${this.domainAdminBaseUrl}user-update`; }

    // Register flow api controller
    get listOfCountriesUrl() { return this.registerBaseUrl + 'countries'; }

    // Domain User API Controller
    get domainUserAuthenticationUrl() { return this.domainUserBaseUrl + 'authentication'; }
    get sendVerificationEmailUrl() { return this.domainUserBaseUrl + 'email-verification';}
    get domainUserDetailsUrl() { return this.domainUserBaseUrl + 'user'; }
    get updateDomainUserDetailsUrl() { return this.domainUserBaseUrl + 'user'; }
    get changeDomainUserPasswordUrl() { return this.domainUserBaseUrl + 'user-password'; }

    // Superadmin api controller
    get allAdminRolesUrl() { return this.adminBaseUrl + 'app-role'; }
    get allApplicationsUrl() { return this.adminBaseUrl + 'app'; }
    get addApplicationUrl() { return this.allApplicationsUrl; }
    get updateApplicationUrl() { return this.allApplicationsUrl; }

    get adminApplicationResourcesUrl() { return this.adminBaseUrl + 'app-resource'; }
    get addAdminApplicationResourceUrl() { return this.adminApplicationResourcesUrl; }
    getAdminDeleteApplicationResourceUrl(resourceId) { return `${this.adminApplicationResourcesUrl}/${resourceId}`; }

    get applicationRolesUrl() { return this.adminBaseUrl + 'app-role'; }
    get addApplicationRoleUrl() { return this.applicationRolesUrl; }
    getDeleteApplicationRoleUrl(roleId: number) { return `${this.applicationRolesUrl}/${roleId}` ;}
    get adminAuditLogUrl() { return this.adminAuditBaseUrl; }
    get adminAuditReportUrl() { return this.adminAuditBaseUrl; }
    get adminAuthenticationUrl() { return this.adminBaseUrl + 'authentication'; }
    // Force Change Password
    get applicationDomainsUrl() { return this.adminBaseUrl + 'domain'; }
    get addAdminDomainUrl() {return this.adminBaseUrl + 'domain'; }
    get updateAdminDomainSettingsUrl() { return this.adminBaseUrl + 'domain-configurations'; }
    get adminDomainDetailsUrl() {return this.adminBaseUrl + 'domain-details'; }
    // DOmain Admin APIs
    get updateDomainOauthConfigUrl() { return this.adminBaseUrl + 'oauth-config'; }
    get allOpenRegistrationsUrl() { return this.adminBaseUrl + 'register'; }
    // Registration APIs

    getAdminChangeOrgStatusUrl(domainId: number){ return this.applicationDomainsUrl + '-enable/' + domainId; }
    get allAdminRolesWithAResourceUrl() { return this.adminBaseUrl + 'role'; }
    get adminUsersUrl() { return this.adminBaseUrl + 'user'; }
    get adminDeleteUsersByEmailUrl() { return this.adminBaseUrl + 'user';}
    get addAdminUserUrl() { return this.adminBaseUrl + 'user'; }
    getToggleAdminUserStateUrl(userId: number) { return `${this.adminBaseUrl}user-enable/${userId}`; }
    getAdminChangeUserPasswordUrl(userId: number) { return `${this.adminBaseUrl}user-password/${userId}`; }
    getAdminChangeUserLoginModeUrl(userId: number) { return `${this.adminBaseUrl}user-security/${userId}`; }
    get adminBulkAddUsersUrl() { return `${this.adminBaseUrl}user/bulk`; }
    get adminUserDetailsReportUrl() { return `${this.adminBaseUrl}user/report`; }
    getResetAdminUserUrl(userId: number) { return `${this.adminBaseUrl}user-reset/${userId}`; }
    get adminBulkUploadUserRolesUrl() { return `${this.adminBaseUrl}/user-role`;}
    getAdminUserRolesUrl(userId: number) { return `${this.adminBaseUrl}user-role/${userId}`; }
    getUpdateAdminUserRolesUrl(userId: number) { return `${this.adminBaseUrl}user-role/${userId}`; }
    getUpdateAdminUserDetailsUrl(userId: number) { return `${this.adminBaseUrl}user/${userId}`; }
    getAdminUserDetailsByIdUrl(userId: number, domainId: number) { return `${this.adminBaseUrl}domain/${domainId}/user/${userId}`; }
    getToggleAdminUserVerificationStatusUrl(userId: number) { return `${this.adminBaseUrl}email-verification/${userId}`; }
    getToggleAdminUserMFAStatusUrl(userId: number) { return `${this.adminBaseUrl}mfa-verification/${userId}`; }
    getAllDomainResourceByDomain(appName: string, domainId: number) { return `${this.adminBaseUrl}${appName}/domain/${domainId}/resource`; }
    // getDomainUserChangePasswordOrLoginModeUrl(userId: number) { return `${this.domainBaseUrl}user-security/${userId}`; }
    // getUpdateAdminUserDetailsUrl(userId: number) { return `${this.domainBaseUrl}user/${userId}`; }

    // IP Management URL(s) under Superadmin api controller
    get ipManagementUrl() { return this.adminBaseIpUrl; } // all the URLs are same, hence keeping only one.

}
